module.exports = __webpack_public_path__ + "static/media/garden.52ab68e1.svg";